/**
 * Utilitário para formatação de preços
 */

import { RoundHelper } from "./roundHelper";

/**
 * Formata um valor numérico para o formato de moeda brasileira
 * @param price - Valor numérico do preço
 * @param showCurrency - Se deve incluir o símbolo (default: true)
 * @returns String formatada como "R$ X,XX" ou "Grátis" para valores zero
 */
export const formatPrice = (
  price: number,
  showCurrency: boolean = true,
): string => {
  if (price === 0) {
    return 'Grátis';
  }

  const formattedValue = RoundHelper.toNumber(price);
  return showCurrency ? RoundHelper.toFormatted(price) : formattedValue.toFixed(2);
};

/**
 * Obtém o preço formatado de um objeto de frete
 * Prioriza formated_price se disponível, senão formata o price
 * @param shippingOption - Objeto com informações de frete
 * @returns String formatada do preço
 */
export const getShippingPrice = (shippingOption: {
  price?: number;
  formated_price?: string;
  is_scheduled?: boolean;
}): string => {
  // Se já tem formated_price (mock), usa ele
  if (shippingOption.formated_price) {
    return shippingOption.formated_price;
  }

  // Se tem price (API real), formata
  if (typeof shippingOption.price === 'number' 
    && (
      !shippingOption.is_scheduled
      || (shippingOption.is_scheduled && shippingOption.price > 0))
    ) {
    return formatPrice(shippingOption.price);
  }

  // Fallback
  return 'Consultar';
};
